import $ from "jquery";

$(document).ready(function () {
    $(".video-item").click(function() {
        window.open($(this).find("a").attr("href"));
        return true;
    });
});

